import { render, staticRenderFns } from "./AreasProtegidasComSoja2324VegaParaguai.vue?vue&type=template&id=d70f668e&lang=pug"
import script from "./AreasProtegidasComSoja2324VegaParaguai.vue?vue&type=script&lang=js"
export * from "./AreasProtegidasComSoja2324VegaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports